import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';
import { ProductsComponent } from './products.component'
import { EditProductSmartComponent } from './edit-product/edit-product-smart.component';
import { AllProductsComponent } from './all-products/all-products.component';
import { NewProductSmartComponent } from './new-product/new-product-smart.component';
import { ProductsHistoryComponent } from './products-history/products-history.component';
//ProductsImportComponent
import { ProductsImportComponent } from './products-import/products-import.component';

const productsRoutes: Routes = [
  {
    path: 'all-products', component: AllProductsComponent
  },
  {
    path: 'edit-product/:id', component: EditProductSmartComponent
  },
  {
    path: 'add-product', component: NewProductSmartComponent
  },
  {
    path: 'products-history', component: ProductsHistoryComponent
  },
  {
    path: 'products-import', component: ProductsImportComponent
  },
  { path: 'pinless-products', loadChildren: () => import('../products/pinless-products/pinless-products.module').then(m => m.PinlessProductsModule) },

  {
    path: '', redirectTo: 'all-products', pathMatch: 'full'
  },
  {
    path: '**', component: PageNotFoundComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(productsRoutes)],
  exports: [RouterModule]
})
export class ProviderRoutingModule { }
